// react
import { Cell, Column, Table } from "fixed-data-table-2";
// dependencies
import { List, Map } from "immutable";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

import Spinner from "../../../../components/Spinner";
// components
import TableCell from "./Cell";

// actions
import { StateChange } from "../../../../actions/page.actions";

// utils
import Cookies from "../../../../utils/Cookies";

import Colors from "../../../../constants/Colors";
import EmptySearchTableMessage from "../../../../pageTemplates/InfoPageTemplate/EmptySearchTableMessage";
// constants
import Config from "../../Config";

// props
const propTypes = {
	width: PropTypes.number.isRequired,
	height: PropTypes.number.isRequired,
	isFetching: PropTypes.bool.isRequired,
	storeColumnWidthsInCookies: PropTypes.bool.isRequired,
	directoryList: PropTypes.instanceOf(List),
	columns: PropTypes.instanceOf(List),
	userMap: PropTypes.instanceOf(Map),
	columnWidths: PropTypes.instanceOf(Map),
	fixedColumns: PropTypes.instanceOf(Map),
	departmentMap: PropTypes.instanceOf(Map),
	userSelectionMap: PropTypes.instanceOf(Map),
	onCheckboxChange: PropTypes.func,
	changeState: PropTypes.func.isRequired,
};

class SearchResults extends React.Component {
	onColumnResizeEndCallback = (newColumnWidth, columnKey) => {
		if (this.props.storeColumnWidthsInCookies) {
			let colWidths = Cookies.getImmutable("directoryColWidths", Map());
			colWidths = colWidths.set(columnKey, newColumnWidth);
			Cookies.set("directoryColWidths", colWidths);
		}

		this.props.changeState(["columnWidths", columnKey], newColumnWidth);
	};

	handleDoubleClick = (columnKey) => {
		// eslint-disable-next-line no-undef
		if (process.env.NODE_ENV !== "production") {
			this.props.changeState(["fixedColumns", columnKey], !this.props.fixedColumns.get(columnKey, false));
		}
	};

	handleCheckboxChange = (userId, nextValue) => {
		const { onCheckboxChange = () => {} } = this.props;
		onCheckboxChange(userId, nextValue);
	};

	render() {
		const {
			width,
			height,
			userMap = Map(),
			directoryList = List(),
			columns = List(),
			isFetching,
			columnWidths = Map(),
			fixedColumns = Map(),
			departmentMap = Map(),
			userSelectionMap = Map(),
		} = this.props;

		const tableWidth = width;
		const rowCount = directoryList.size;

		const tableColumns = columns.map((field, idx) => {
			return (
				<Column
					isResizable={true}
					key={field.get("_id")}
					columnKey={field.get("_id")}
					// fix the first column of every table.
					// This is a hack to fix an apparent bug in fixed-data-table-2
					fixed={fixedColumns.get(field.get("_id"), false) || idx === 0}
					width={columnWidths.get(field.get("_id"), Config.defaultColumnWidth)}
					cell={
						<TableCell
							onCheckboxChange={this.handleCheckboxChange}
							userSelectionMap={userSelectionMap}
							type={field.get("type")}
							fieldData={field}
							userMap={userMap}
							data={directoryList}
							departments={departmentMap}
						/>
					}
					header={
						<Cell onDoubleClick={() => this.handleDoubleClick(field.get("_id"))} className="header-cell">
							{field.get("name")}
						</Cell>
					}
				/>
			);
		});

		const renderContent = () => {
			let content = (
				<Table
					rowHeight={40}
					height={height}
					headerHeight={40}
					width={tableWidth}
					rowsCount={rowCount}
					isColumnResizing={false}
					onColumnResizeEndCallback={this.onColumnResizeEndCallback}
					rowAttributesGetter={(ii) => ({
						"data-testid": `table-row-${directoryList.getIn([ii], "")}`,
						"data-userid": directoryList.getIn([ii], ""),
					})}
				>
					{tableColumns}
				</Table>
			);

			if (isFetching) {
				content = (
					<div style={{ textAlign: "center" }}>
						<Spinner size={30} color={Colors.blue} />
					</div>
				);
			} else if (rowCount === 0) {
				content = <EmptySearchTableMessage />;
			}

			return content;
		};

		return (
			<section className="search-results-container">
				<div data-testid="user_table" className="cp-table" style={{ height }}>
					{renderContent()}
				</div>
			</section>
		);
	}
}

SearchResults.propTypes = propTypes;

const mapStateToProps = (state, ownProps) => {
	const columnWidths = ownProps.storeColumnWidthsInCookies
		? Cookies.getImmutable("directoryColWidths", Map())
		: state.page.getIn([ownProps.storeName, "columnWidths"]);

	return {
		columnWidths,
		userMap: state.users.get("users"),
		directoryList: state.users.get("directoryList"),
		departmentMap: state.departments.get("departmentMap"),
		isFetching: state.users.getIn(["_currentQuery", "isFetching"]),
		fixedColumns: state.page.getIn([ownProps.storeName, "fixedColumns"]),
		userSelectionMap: state.selections.getIn(["selectionMaps", ownProps.selectionObjectId]),
	};
};

const mapDispatchToProps = (dispatch, ownProps) => ({
	changeState: (keyPath, value) => dispatch(StateChange(ownProps.storeName, keyPath, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchResults);
